import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import dayjs from 'dayjs';

import ErrorBoundary from '../errorBoundary/ErrorBoundary';
import ErrorFallback from '../errorBoundary/ErrorFallback';

import './themes/Primary.css';

const StyledLayout = styled.div`
  background: ${(props) => props.$bg || 'rgb(237, 242, 247)'};
  min-height: 100vh;
  /* Sticky footer: content flexes, so the © line sits at the viewport bottom
     on short pages instead of floating mid-screen — same spot on every page. */
  display: flex;
  flex-direction: column;
  & > section {
    flex: 1 0 auto;
  }
  /* Bottom padding contains the footer <p>'s collapsing margin (which would
     otherwise escape this container and reveal the white body bg as a strip). */
  padding-bottom: 2rem;
`;

const StyledHeader = styled.header`
  text-align: ${(props) => props.$align || 'center'};
  margin: 0;
  margin-bottom: 1rem;
  padding: 0.5rem;
  padding-left: ${(props) => (props.$align === 'left' ? '1.5rem' : '0.5rem')};
  background: rgba(0, 0, 0, 0.9);
`;

const PublicLayout = ({
  children,
  background,
  footerClassName,
  footerVariant,
  hideFooterLinks,
  headerBadge,
  headerAlign,
}) => {
  // 'dark' restyles the Privacy/Terms links legibly on dark-brand backgrounds
  // (the default anchor blue is unreadable there). Pages collecting PII must
  // keep these links visible — prefer this over hideFooterLinks.
  const footerLinkClass =
    footerVariant === 'dark'
      ? 'text-neutral-300 underline underline-offset-2 hover:text-white'
      : '';
  return (
    <StyledLayout $bg={background}>
      <StyledHeader $align={headerAlign}>
        {/* inline-flex keeps the (img + optional badge) group centered exactly
            like the bare img was; renders identically when headerBadge unset. */}
        <span className="inline-flex items-center gap-3">
          <img
            src={process.env.PUBLIC_URL + '/VR-Full-White-Horizontal-01.png'}
            className="my-2"
            alt="Veritas Ratings"
            title="Veritas Ratings"
            style={{ height: 80 }}
          />
          {headerBadge ? (
            <>
              <span
                aria-hidden="true"
                style={{
                  height: 28,
                  width: 2,
                  background: 'rgba(255,255,255,0.25)',
                }}
              />
              <span
                className="text-sm font-medium"
                style={{ color: 'rgb(163,163,163)' }}
              >
                {headerBadge}
              </span>
            </>
          ) : null}
        </span>
      </StyledHeader>
      <section>
        <ErrorBoundary fallback={<ErrorFallback />}>
          <Container>{children}</Container>
        </ErrorBoundary>
      </section>
      <footer>
        {/* One line always: shrink-to-fit on narrow screens, never wrap. */}
        <p
          className={`text-center mt-5 ${footerClassName || ''}`}
          style={{
            whiteSpace: 'nowrap',
            fontSize: 'clamp(0.6rem, 2.9vw, 1rem)',
          }}
        >
          &copy; {dayjs().format('YYYY')} Veritas Ratings &middot; All Rights
          Reserved
          {hideFooterLinks ? null : (
            <>
              {' '}
              &middot;{' '}
              <Link to="/privacy" className={footerLinkClass}>
                Privacy Policy
              </Link>{' '}
              &middot;{' '}
              <Link to="/terms" className={footerLinkClass}>
                Terms of Use
              </Link>
            </>
          )}
        </p>
      </footer>
    </StyledLayout>
  );
};

export default PublicLayout;
